"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFriendlyFilename = getFriendlyFilename;
const slugify_1 = __importDefault(require("slugify"));
const FRIENDLY_FILENAME_LIMIT = 64;
function getFriendlyFilename(url, name) {
    let urlString;
    try {
        urlString = new URL(url).host;
    }
    catch {
        // ignore if we can't parse the url
    }
    const date = new Date().toISOString().substring(0, 10);
    return `${[urlString, name]
        .filter(Boolean)
        .map(s => (0, slugify_1.default)(s))
        .join('-')
        .substring(0, FRIENDLY_FILENAME_LIMIT)}-${date}`;
}
//# sourceMappingURL=friendly-filename.js.map